import { AtHeader, AtText, AtClickable, AtIcon } from '@/components/atoms';

// TYPES
import { ETextVariants } from '@/components/atoms/at-text/at-text.types';
import { EClickableVariants } from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { MlInfoTooltip } from '@/components/molecules/ml-info-tooltip/ml-info-tooltip';

export const mockTextContent = () => {
  return (
    <div className="mb-9.5 lg:mb-0">
      <AtHeader element="h1" alt className="mb-5 lg:mb-12">
        The Oakridge Floorplan
      </AtHeader>

      <div className="mb-4.5 lg:mb-7">
        <AtText
          className="mb-2 text-skin-tertiary lg:mb-3"
          variant={ETextVariants.LABEL}
        >
          Exterior Style
        </AtText>
        <AtHeader element="p" variant="h6" className="text-skin-secondary">
          Craftsman
        </AtHeader>
      </div>

      <div className="mb-7 lg:mb-8">
        <span className="mb-2 flex items-center lg:mb-3.5">
          <AtText
            className="mr-0.6 text-skin-tertiary"
            variant={ETextVariants.LABEL}
          >
            Exterior Price
          </AtText>
          <MlInfoTooltip
            iconName={EIcons.INFO}
            body="Price shown includes exterior style upgrades and location-based adjustments."
          />
        </span>

        <AtHeader className="md:mb-12" element="p" variant="h3" alt>
          $749,000
        </AtHeader>
      </div>

      <AtClickable
        label="Customize & Price"
        variant={EClickableVariants.PRIMARY}
        iconPosition="left"
        interactLocation="test"
      >
        <AtIcon icon={EIcons.THREED} color="var(--color-button-text-primary)" />
      </AtClickable>
    </div>
  );
};

export const mockHeroSlides = [
  {
    id: 'hero-slide-1',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
    disclaimer: 'Rendering may differ from actual build.',
    planName: 'The Oakridge',
  },
  {
    id: 'hero-slide-2',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
    header: 'Limited-Time Offer!',
    planName: 'The Oakridge',
    button: {
      text: 'Explore Offer',
      url: '/promo',
    },
  },
  {
    id: 'hero-slide-3',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
  },
  {
    id: 'hero-slide-4',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
  },
];

export const mockModelHomeSlides = [
  {
    id: 'model-slide-1',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
    disclaimer: 'Rendering may differ from actual build.',
    planName: 'The Oakridge',
  },
  {
    id: 'model-slide-2',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
  },
  {
    id: 'model-slide-3',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
  },
  {
    id: 'model-slide-4',
    image: {
      src: {
        mobile: '/assets/FPO.webp',
        tablet: '/assets/FPO.webp',
        desktop: '/assets/FPO.webp',
      },
      alt: 'Default image',
    },
  },
];

export const orCarouselHeroMockData = {
  autoplay: false,
  slideData: mockHeroSlides,
  textContent: (
    <div>
      <h3>Explore Your Dream Home</h3>
      <p>Discover stunning exteriors and customizable options.</p>
    </div>
  ),
};
